"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.multiplyScalarDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var multiplyScalarDependencies = exports.multiplyScalarDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createMultiplyScalar: _factoriesAny.createMultiplyScalar
};